import { apiClient, CONVERSATIONS } from '../../../shared/api';
import { DEFAULT_PER_PAGE } from '../../../shared/constants';

export const fetchConversation = async (conversationId) => {
  const params = {
    include: 'messages,messages.sender',
  };

  const response = await apiClient.get(`${CONVERSATIONS}/${conversationId}`, {
    includeWebsite: true,
    params,
  });

  return response.data;
};

export const fetchConversations = async ({
  subject,
  page = 1,
  perPage = DEFAULT_PER_PAGE,
}) => {
  const params = {
    filter: {
      subject: subject,
    },
    include: 'last_message,last_message.sender',
    page: {
      number: page,
      size: perPage,
    },
  };

  const response = await apiClient.get(CONVERSATIONS, {
    includeWebsite: true,
    params,
  });

  return response.data;
};
